import React, { useState } from "react";
import { CollectionCreateIcon } from "../../../assets/img/CollectionCreateIcon";
import { CollectionDefaultValue } from "../../../defalult/CollectionDefaultValue";
import {
  FilterWrapper,
  MarketplaceFilterButton,
  MarketplaceFilterCol,
  MarketplaceFilterCollection,
  MarketplaceFilterDropdownCollection,
  MarketplaceFilterSearch,
} from "./MarketplaceFilter.styled";

const collections = CollectionDefaultValue;

export const CollectionsFilter = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  return (
    <FilterWrapper
      onMouseLeave={() => {
        setShowDropdown(false);
      }}>
      <MarketplaceFilterButton
        onMouseEnter={() => {
          setShowDropdown(true);
        }}>
        {CollectionCreateIcon()} Collections
      </MarketplaceFilterButton>
      <MarketplaceFilterDropdownCollection showDropdown={showDropdown}>
        <MarketplaceFilterSearch placeholder='Seаrch Collections'></MarketplaceFilterSearch>
        <MarketplaceFilterCol>
          {collections.map((collection, i) => (
            <MarketplaceFilterCollection key={i}>
              <img src={collection?.banner} alt='logo' /> <span>{collection?.title}</span>
            </MarketplaceFilterCollection>
          ))}
        </MarketplaceFilterCol>
      </MarketplaceFilterDropdownCollection>
    </FilterWrapper>
  );
};
